import { useQuery } from "@tanstack/react-query";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { getStorePermissionsApi } from "../api/storePermissionsApi";

export const useGetStorePermissionsQuery = (storeId: StoreId | null) => {
  return useQuery({
    queryKey: ["stores", storeId, "permissions"],
    queryFn: () => getStorePermissionsApi(storeId!),
    enabled: !!storeId,
  });
};
